module.exports = __webpack_public_path__ + "img/SE.c37f1b98.svg";